module.exports = __webpack_public_path__ + "static/media/dashboard_dark.7654cb21.svg";